type CrossProps = {
  strokeColor?: string | null | undefined;
};

const Cross = ({ strokeColor }: CrossProps) => (
  <svg focusable={false} viewBox='0 0 24 24'>
    <path
      stroke={strokeColor || 'inherit'}
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M5 19L19 5m0 14L5 5'
    />
  </svg>
);

export default Cross;
